import { StockFullStockReportData } from '../../../../types/FullStockReportTypes';
import { initDataList } from '../../../../../core/types/coreTypes';

export const initFullStockReportData: StockFullStockReportData = {
  ...initDataList,
  freeReservedCostSum: 0,
  wipCostSum: 0,
  dueInCostSum: 0,
  totalCostSum: 0,
};
